/**
 * Copyright 2024 SweetCode. All rights reserved.
 *
 * All event listeners
 * */

/**
 * Source: https://help.taboola.com/hc/en-us/articles/360009027493-Tracking-Dynamic-Conversion-Values-
 **/

// Pixel load event listener
jQuery(document).on("pmw:load-pixels", () => {

	if (wpmDataLayer?.pixels?.taboola?.account_id && !wpmDataLayer?.pixels?.taboola?.loaded) {
		if (wpm.consent.canPixelBeFired("marketing", "Taboola")) wpm.loadTaboolaPixel()
	}
})

// view search event
jQuery(document).on("pmw:search", () => {

	try {
		if (wpm.canNotFireTaboolaEvent()) return

		let data = {
			id    : wpmDataLayer.pixels.taboola.account_id,
			notify: "event",
			name  : wpmDataLayer.pixels.taboola.event_names.search,
		}

		_tfa.push(data)
		pmw.console.log("Taboola: search event sent", data)

	} catch (e) {
		console.error(e)
	}
})

// add-to-cart event
// No product value transmitted, as Taboola only supports the "revenue" field.
jQuery(document).on("pmw:add-to-cart", (event, product) => {

	try {
		if (wpm.canNotFireTaboolaEvent()) return

		let data = {
			id      : wpmDataLayer.pixels.taboola.account_id,
			notify  : "event",
			name    : wpmDataLayer.pixels.taboola.event_names.add_to_cart,
			quantity: product.quantity,
			currency: product.currency,
			revenue : product.quantity * product.price,
		}

		_tfa.push(data)
		pmw.console.log("Taboola: add_to_cart event sent", data)

	} catch (e) {
		console.error(e)
	}
})

// add-to-wishlist event
// No product value transmitted, as Taboola only supports the "revenue" field.
jQuery(document).on("pmw:add-to-wishlist", (event, product) => {

	try {
		if (wpm.canNotFireTaboolaEvent()) return

		let data = {
			id      : wpmDataLayer.pixels.taboola.account_id,
			notify  : "event",
			name    : wpmDataLayer.pixels.taboola.event_names.add_to_wishlist,
			quantity: product.quantity,
			currency: product.currency,
			revenue : product.quantity * product.price,
		}

		_tfa.push(data)
		pmw.console.log("Taboola: add_to_wishlist event sent", data)

	} catch (e) {
		console.error(e)
	}
})

// start-checkout event
// No product value transmitted, as Taboola only supports the "revenue" field.
jQuery(document).on("pmw:begin-checkout", () => {

	try {
		if (wpm.canNotFireTaboolaEvent()) return

		let data = {
			id    : wpmDataLayer.pixels.taboola.account_id,
			notify: "event",
			name  : wpmDataLayer.pixels.taboola.event_names.start_checkout,
		}

		_tfa.push(data)
		pmw.console.log("Taboola: start_checkout event sent", data)

	} catch (e) {
		console.error(e)
	}
})

// view-content event
// No product value transmitted, as Taboola only supports the "revenue" field.
jQuery(document).on("pmw:view-item", (event, product = null) => {

	try {
		if (wpm.canNotFireTaboolaEvent()) return

		let data = {
			id    : wpmDataLayer.pixels.taboola.account_id,
			notify: "event",
			name  : wpmDataLayer.pixels.taboola.event_names.view_content,
		}

		if (product) {
			data.currency = product.currency
			data.quantity = product.quantity
			data.revenue  = product.quantity * product.price
		}

		_tfa.push(data)
		pmw.console.log("Taboola: view_content event sent", data)

	} catch (e) {
		console.error(e)
	}
})

// view order received page event
jQuery(document).on("pmw:view-order-received-page", () => {

	try {
		if (wpm.canNotFireTaboolaEvent()) return

		let data = {
			id      : wpmDataLayer.pixels.taboola.account_id,
			notify  : "event",
			name    : wpmDataLayer.pixels.taboola.event_names.purchase,
			revenue : wpmDataLayer.order.value.marketing,
			currency: wpmDataLayer.order.currency,
			orderid : wpmDataLayer.order.id,
		}

		if (wpmDataLayer.order.items) {
			let itemCount = 0
			wpmDataLayer.order.items.forEach(item => {
				itemCount += parseInt(item.quantity)
			})

			data.quantity = itemCount
		}

		_tfa.push(data)
		pmw.console.log("Taboola: purchase event sent", data)

	} catch (e) {
		console.error(e)
	}
})
